module.exports = __webpack_public_path__ + "static/media/1-en.7ea8b6be.svg";